export default __webpack_public_path__ + "static/teal-hero-watch-958f73746bdfd4977d1717ae5da1b265.png";